import TokenManager from '@viome/viome-base/src/api/TokenManager';
import environment from '@config/environment';
import { Loader } from '@design-system/Loader';
import { useState } from 'react';
import { KEYS, LocalStorage } from '@utils/LocalStorage';

export const AddOrRemoveProducts = () => {
  const localStorageUser = LocalStorage.getItem(KEYS.BOOTUP);
  const { subscriptionId } = localStorageUser && JSON.parse(localStorageUser);
  const [span] = useState(() => Date.now().valueOf());
  const OLD_ADD_REMOVE_PRODUCT_PAGE_URL = `${environment.OLD_BASE_URL}/more/manage-subscription/change-plan/${subscriptionId}?in_iframe=true&span=${span}&token=${TokenManager.getAuthToken()}`;
  const IFRAME_HEIGHT = '100%';
  const IFRAME_WIDTH = '100%';
  const [iframeLoading, setIframeLoading] = useState(true);
  return (
    <div>
      {iframeLoading && (
        <Loader />
      )}
      <iframe
        src={OLD_ADD_REMOVE_PRODUCT_PAGE_URL}
        height={IFRAME_HEIGHT}
        width={IFRAME_WIDTH}
        style={{ height: '100vh' }}
        frameBorder="0"
        allowFullScreen
        onLoad={() => setIframeLoading(false)}
      />
    </div>
  );
};
